import { Button, Flex, useToast } from "@chakra-ui/react";
import React from "react";
import { FiSave } from "react-icons/fi";
import { ProfileViewModel } from "../../ProfileViewModel";

interface ProfileButtonsSectionProps {
  model: ProfileViewModel;
}

export const ProfileButtonsSection: React.FC<ProfileButtonsSectionProps> = ({ model }) => {
  const toast = useToast();

  return (
    <Flex w="100%" mt="6px">
      <Button
        onClick={() => model.saveProfileData(toast)}
        bg="accent"
        color="white"
        borderRadius="12px"
        fontWeight="700"
        px="32px"
        py="13px"
        h="auto"
        leftIcon={<FiSave />}
        boxShadow="0 8px 20px rgba(229,31,68,0.22)"
        _hover={{ bg: "#c41a3a" }}
      >
        Zapisz zmiany
      </Button>
    </Flex>
  );
};
